import { useQuery } from "@tanstack/react-query";
import { preferenceService } from "../../api";
import { preferenceKeys } from "../../api/preferences/preferenceKeys";
import { Preference } from "../../types/preference";

const preferences: Preference[] = [];
const preferenceFetcher = () => preferenceService.index().then((r) => r.data.data);
export const usePreferencesQuery = () => {
	const { data, isLoading } = useQuery({
		queryKey: preferenceKeys.index,
		queryFn: preferenceFetcher,
	});

	return {
		data: data || preferences,
		isLoading,
	};
};
